export default __webpack_public_path__ + "static/media/guia-3.d929234c.svg";